export const selectByodInfo = (state) => ({
  byod: state.devicesInfo?.byod,
  imei: state.devicesInfo?.imei
});
